export default __webpack_public_path__ + "static/media/Slider image 02.9472c062.PNG";